import React,{useState} from 'react';
import Box from '@mui/material/Box';
import {TemplateWrapper,ButtonsContainer,Button,TemplateName} from './Theme'
export const Template = ({width,height,Content,onMouseEnter,onMouseLeave,ButtonsContent,selectedTemplate}) => {

    return (
        <TemplateWrapper   
        onMouseEnter={onMouseEnter && onMouseEnter}
        onMouseLeave={onMouseLeave && onMouseLeave}
        selectedTemplate={selectedTemplate}
        >
        <Box
        height={height}
        width={width}
        my={4}
        display="flex"
        alignItems="center"
        p={2}
        sx={{  border:selectedTemplate ?'2px solid var(--Blues-Blue-Main, #2555EF)' : '2px solid #E1E1E7' ,
        borderRadius: '10px' ,position:'relative',backgroundColor:'#fff',position:'relative'}}
      >
        {Content}
        {ButtonsContent &&  ButtonsContent }
        
       
      </Box>
      </TemplateWrapper>
    );
};
